import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { SeriesCard } from 'src/component/ui/series-card'
import { HustlerProgramme, Programme } from 'src/dao/core-dao'
import { usePreviewSeries } from 'src/hook/use-preview-series'

export const ProgrammeList = ({
  programmes,
}: {
  programmes: Programme[]
  startedProgrammes: HustlerProgramme[]
}): React.ReactElement => {
  const { previewSeriesModal, startSeriesPreview } = usePreviewSeries()

  return (
    <>
      {previewSeriesModal}
      <Row style={{ flex: 1 }}>
        {programmes.map((p) => (
          <Col key={p.id} md={6} lg={4}>
            <div className="d-flex justify-content-center py-2">
              <SeriesCard.Default series={p} onAction={() => startSeriesPreview(p)} />
            </div>
          </Col>
        ))}
      </Row>
    </>
  )
}
